import http from '@/core/http'
import { last, size } from 'lodash'

const url = 'reference-comission-plans'

const state = {
  itens: [],
  planValues: [],
  itemValueRange: {
    level: 1,
    aliquot: 0
  },
  listValues: [],
  item: {
    id: null,
    name: ''
  },
  totalItens: 0,
  totalItemSelect: 0,
}

const actions = {
    
  /* range values */
  addRangeValues: ({ commit }, payload) => {
    commit('ADD_VALUE_RANGE', payload)
    return Promise.resolve(true)
  },
  listValueRange: ({ commit }, payload) => {
    commit('LIST_VALUE_RANGE', payload)
    return Promise.resolve(true)
  },
  editValuesRange: ({ commit }, payload) => {
    commit('EDIT_VALUE_RANGE', payload)
    return Promise.resolve(true)
  },

  deleteValueRange: ({ commit }, payload) => {
    commit('DELETE_VALUE_RANGE', payload)
    return Promise.resolve(true)
  },

  clearValueRange: ({ commit }, payload) => {
    commit('CLEAR_VALUE_RANGE', payload)
    return Promise.resolve(true)
  },
  getItens: async ({ commit }, payload) => {
    const result = await http.get(url, {params: { ...payload }})
    commit('LISTA_ITENS', result.data)
    return Promise.resolve(result)
  },

  cadastrarItem: async (_, payload) => {
    const result = await http.post(url, payload)
    return Promise.resolve(result)
  },

  editarItem: async (_, payload) => {
    const result = await http.put(url, payload)
    return Promise.resolve(result)
  },

  deletarItem: async (_, payload) => {
    const result = await http.delete(url, { params: payload })
    return Promise.resolve(result)
  },
  
  getItem: async ({ commit, getters }, payload) => {
    const result = await http.get(url, { params: { _addlFilter: { 'rcp:id_=': payload.id }} })
    commit('LISTA_ITEM', { payload: result, getters })
    Promise.resolve(result)
  },

  limparItem: ({ commit }) => {
    commit('LIMPAR_ITEM')
  },

  clearModal: ({ commit }) => {
    commit('CLEAR_ITENS')
  }
}

const mutations = {
  'ADD_TYPE_OPERATOR' (state, payload) {
    if (payload.edit) {
      state.listOperator[payload.edit] = payload
      return Promise.resolve(true)
    }
    state.listOperator.push(Object.assign({}, payload))
    return Promise.resolve(true)
  },
  
  'DELETE_TYPE_OPERATOR' (state, payload) {
    const filtro = state.listOperator.filter((v, k) => k !== payload)
    state.listOperator = filtro
  },
  'CLEAR_TYPE_OPERATOR' (state) {
    state.itemOperator =  {
      type: '',
      condition: '',
      value: 0
    }
  },
  /* Pagamentos */
  'ADD_PAGAMENTOS' (state, payload) {
    state.listPagamentos.push(Object.assign({}, payload))
    return Promise.resolve(payload)
  },
  
  'DELETE_PAGAMENTOS' (state, payload) {
    const filtro = state.listPagamentos.filter((v, k) => k !== payload)
    state.listPagamentos = filtro
  },
  'INCREMENT_PAGAMENTOS' (state) {
    const item = last(state.listPagamentos)
    state.itemPagamentos = {
      minRange: item.maxRange,
      maxRange: item.maxRange + 1,
      value: 0,
      comissionTypeId: item.comissionTypeId
    }
  },
  'CLEAR_PAGAMENTOS' (state) {
    const item = last(state.listPagamentos)
    if (size(item)) {
      state.itemPagamentos =  Object.assign({}, {
        minRange: '',
        maxRange: '',
        value: 0,
        comissionTypeId: item.comissionTypeId
      })
    } else {

      state.itemPagamentos =  {
        minRange: '',
        maxRange: '',
        value: 0,
        comissionTypeId: ''
      }
    }

  },
  
  /* Values ranges */
  'ADD_VALUE_RANGE' (state, payload) {
    payload.aliquot = parseFloat(payload.aliquot).toFixed(2)
    if (payload.edit !== undefined) {
      state.listValues[payload.edit] = payload
      const currentMaxLevel = state.listValues.reduce((maxLevel, item) => Math.max(maxLevel, item.level), 0)
      state.itemValueRange = {
        level: currentMaxLevel + 1,
        aliquot: 0
      }
      return Promise.resolve(true)
    }
    state.listValues.push(Object.assign({}, payload))
    state.listValues.forEach((item, index) => {
      item.level = index + 1
    })
    payload.aliquot = ''
    payload.level += 1
  },
  'LIST_VALUE_RANGE' (state, payload) {
    state.listValues.push(Object.assign({}, payload))
    const currentMaxLevel = state.listValues.reduce((maxLevel, item) => Math.max(maxLevel, item.level), 0)
    state.itemValueRange = {
      level: currentMaxLevel + 1,
      aliquot: 0
    }
  },
  'EDIT_VALUE_RANGE' (state, payload) {
    state.itemValueRange = state.listValues[payload]
    state.itemValueRange.edit = payload
  },

  'DELETE_VALUE_RANGE' (state, payload) {
    const filtro = state.listValues.filter((v, k) => k !== payload)
    state.listValues = filtro
  
    // Após a exclusão, reatribue os níveis
    state.listValues.forEach((item, index) => {
      item.level = index + 1
    })
  },
  'CLEAR_VALUE_RANGE' (state) {
    state.itemValueRange.aliquot = ''
  },
  'LIST_CONDITIONS_TYPES'(state, payload) {
    state.conditionTypes = payload.resultMap
  },
  'LISTA_TYPES_CONTRACT'(state, payload) {
    state.contractTypes = payload.resultMap
    state.totalTypes = payload.totalItens
  },
  'LISTA_TYPES_COMISSION'(state, payload) {
    state.comissionTypes = payload.resultMap
    state.totalComissionTypes = payload.totalItens
  },
  'EDIT_ITEM_TYPE_CONTRACT'(state, payload) {
    state.itemTypeContract = payload
  },

  'CLEAR_ITEM_TYPE_CONTRACT'(state) {
    state.itemTypeContract = { name: '', description: ''}
  },

  'LISTA_ITENS' (state, payload) {
    state.itens = payload.resultMap
    state.totalItens = payload.totalItens
  },

  'LISTA_ITEM' (state, { payload, getters }) {
    state.item = payload.data.resultMap[0]
    
    const dados = payload.data.resultMap[0]
    if (dados && dados.conditions) {
      state.listOperator = payload.data.resultMap[0].conditions || []
    }

    if (dados && dados.contractRangeValues) {
      state.listValues = payload.data.resultMap[0].contractRangeValues || []      

      // inpede editar o tipo de contrato dentro de Receitas.
      if (state.item.contractRangeValues[0]) state.item.comissionTypeId = getters.listTipeSelectComissionFilter(false, state.item.contractRangeValues[0].comissionTypeId)[0]
      if (payload.data.resultMap[0].contractTypeId === 'CPA') {
        state.listPagamentos = payload.data.resultMap[0].contractRangeValues || []
      }
    }
  },

  'LIMPAR_ITEM' (state) {
    state.itemValueRange = {
      level: 1,
      aliquot: ''
    }
    state.item = {
      id: null,
      name: ''
    }
  },
  'CLEAR_ITENS' (state) {
    state.totalItens = 0
    state.listValues = []
  }
}

const getters = {
  listaItens: state => state.itens,
  totalItens: (state) => state.totalItens,
  totalItemSelect: (state) => state.totalItemSelect,
  item: state => state.item,
  itemValueRange: state => state.itemValueRange,
  listLancamentoRangeValores: state => state.listValues,
}

export default { namespaced: true, state, actions, mutations, getters }